import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Transfer } from '@platform/components';
import { getPropsFromMeta } from "../../utils"
import CompMeta from '../../meta/LowCodeComponents/Transfer';

/**
 * @class NCTransfer
 * @column 1
 * @compType 1
 * @canAppend false
 * @path LowCodeComponents.NCTransfer
 * @label 树状表格
 *
 */
class NCTransfer extends Component {
    constructor(props) {
        super(props);
    }
    static propTypes = {
         /**
         * @title 区域编码
         * @description 组件标识
         */
          moduleId: PropTypes.string.isRequired,
        /**
         * @title 渲染类型
         * @description 渲染类型
         */
        treeType: PropTypes.bool,
        /**
        * @title 显示搜索框
        * @description 显示搜索框
        */
        showSearch: PropTypes.bool,
        /**
        * @title 搜索框的提示文字
        * @description 搜索框的提示文字
        */
        searchPlaceholder: PropTypes.string,
        /**
        * @title 显示复选框
        * @description 显示复选框
        */
        checkable: PropTypes.bool,
        /**
        * @title 显示搜索框
        * @description 显示搜索框
        */
        checkable: PropTypes.bool,
        /**
         * @title 样式名
         * @description 样式名
         */
        className: PropTypes.string,
        /**
        * @title 显示排序按钮
        * @description 显示排序按钮
        */
        showMoveBtn: PropTypes.bool,
        /**
        * @title 列表为空时显示的内容
        * @description 列表为空时显示的内容
        */
        notFoundContent: PropTypes.string,
        /**
      * @title 是否可见
      * @description 是否可见
      */
        visible: PropTypes.bool,
    }
    static defaultProps = {
        dataSource: [],
        treeType: false,
        showSearch: false,
        checkable: true,
        notFoundContent: '暂无数据',
        targetKeys:[]
    }
    static getCompMeta() {
        return CompMeta;
    }


    render() {
        return (
            <React.Fragment>
                <Transfer {...this.props} />
            </React.Fragment>
        )
    }
}

export default NCTransfer;
